import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("rect", {
  x: "21",
  y: "15.7656",
  width: "1.50631",
  height: "12",
  rx: "0.753155",
  transform: "rotate(90 21 15.7656)"
}), React.createElement("path", {
  d: "M19.7197 15.9862C20.0126 15.6921 20.4874 15.6921 20.7803 15.9862C21.0732 16.2803 21.0732 16.7572 20.7803 17.0513L17.068 20.7793C16.7751 21.0734 16.3003 21.0734 16.0074 20.7793C15.7145 20.4851 15.7145 20.0083 16.0074 19.7141L19.7197 15.9862Z"
}), React.createElement("path", {
  d: "M20.7803 15.9485C21.0732 16.2426 21.0732 16.7195 20.7803 17.0136C20.4874 17.3078 20.0126 17.3078 19.7197 17.0136L16.0074 13.2857C15.7145 12.9916 15.7145 12.5147 16.0074 12.2206C16.3003 11.9265 16.7751 11.9265 17.068 12.2206L20.7803 15.9485Z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 12C13.3211 12 15 10.3211 15 8.25C15 6.17893 13.3211 4.5 11.25 4.5C9.17893 4.5 7.5 6.17893 7.5 8.25C7.5 10.3211 9.17893 12 11.25 12ZM11.25 13.5C14.1495 13.5 16.5 11.1495 16.5 8.25C16.5 5.35051 14.1495 3 11.25 3C8.3505 3 6 5.35051 6 8.25C6 11.1495 8.3505 13.5 11.25 13.5Z"
}), React.createElement("path", {
  d: "M11.25 12C6.69365 12 3 15.6937 3 20.25C3 20.2742 3.0001 20.2983 3.00031 20.3225C3.00362 20.7067 3.32796 21 3.71217 21H3.78969C4.19066 21 4.5 20.651 4.5 20.25C4.5 16.5221 7.52208 13.5 11.25 13.5V12Z"
})), "IconOut");